import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=77ef9f34&"
import script from "./Package.vue?vue&type=script&lang=ts&"
export * from "./Package.vue?vue&type=script&lang=ts&"
import style0 from "./Package.vue?vue&type=style&index=0&id=77ef9f34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports